import React from "react";
import "../styles/Blog.css";
import { FaLightbulb, FaCode, FaPalette } from "react-icons/fa";

const blogPosts = [
  {
    title: "5 Web Design Trends to Watch in 2025",
    summary: "Explore the latest design innovations that are shaping the future of user experiences.",
    icon: <FaPalette />,
    date: "April 10, 2025"
  },
  {
    title: "Why Your Business Needs a Website in 2025",
    summary: "From visibility to credibility, we break down why a modern website is essential.",
    icon: <FaLightbulb />,
    date: "March 28, 2025"
  },
  {
    title: "Top 10 Tools Every Developer Should Use",
    summary: "Boost productivity and write cleaner code with these essential tools.",
    icon: <FaCode />,
    date: "March 15, 2025"
  }
];

function Blog() {
  return (
    <div className="blog-page container mt-5 mb-5">
      <h1 className="text-center blog-heading">Our Blog</h1>
      <p className="text-center blog-intro mb-4">
        Insights, tips, and updates from our team of developers and designers.
      </p>

      <div className="blog-grid">
        {blogPosts.length > 0 ? (
          blogPosts.map((post, index) => (
            <div className="blog-card" key={index}>
              <div className="blog-icon">{post.icon}</div>
              <h3 className="blog-title">{post.title}</h3>
              <p className="blog-summary">{post.summary}</p>
              <span className="blog-date">{post.date}</span>
            </div>
          ))
        ) : (
          <p className="text-center">No blog posts yet. Stay tuned!</p>
        )}
      </div>
    </div>
  );
}

export default Blog;

